import React from 'react';
import { FrameSizeSelector } from '~/shared/types';

const FrameSizeContext = React.createContext<FrameSizeSelector>('desktop');

export default FrameSizeContext;
